exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3SzY81xJATNB9wkPX2Z1sV {\n  display: flex;\n  justify-content: center;\n}\n.sZ1Ou0zBraXv8vhpQts-L {\n  padding: 0 0.5rem !important;\n  font-weight: 600 !important;\n  font-size: 1.2rem;\n  vertical-align: -0.125rem;\n  width: 33px !important;\n  display: inline-block !important;\n}\n", ""]);

// exports
exports.locals = {
	"checkbox": "_3SzY81xJATNB9wkPX2Z1sV",
	"resourceIcon": "sZ1Ou0zBraXv8vhpQts-L"
};